import React from "react";
import { Loader } from "react-loaders";
import { changeLocation } from "api/Location";
import { getRequest } from "../api/ApiService";

const VERIFY_URL = `${process.env.REACT_APP_API_URL}account/verify/`;

function verifyCallback() {
  changeLocation("/login?verified=1");
}

function AccountVerify({ token }) {
  getRequest(`${VERIFY_URL}${token}/`)
    .then(verifyCallback)
    .catch(verifyCallback);

  return (
    <div className="application-loading">
      <Loader type="ball-scale-ripple" active />
    </div>
  );
}

export default AccountVerify;



// WEBPACK FOOTER //
// ./src/services/account-verify.js